import { Component, EventEmitter, Input, Output } from '@angular/core'
import { LabelType } from '@widgets/label/label.component'

@Component({
  selector: 'bdg-menu-item',
  templateUrl: './menu-item.component.html',
})
export class MenuItemComponent {
  @Input() icon: string

  @Input() label: string

  @Input() labelType: LabelType = 'body-1'

  @Input() disabled: boolean

  @Output() itemClick: EventEmitter<'click'> = new EventEmitter()

  onClick() {
    this.itemClick.emit()
  }
}
